import { useMemo } from 'react'

import useGetBrandVoicesQuery from 'common/api/queries/useGetBrandVoicesQuery'
import useGetCustomerAttributesQuery from 'features/unifiedFlow/api/queries/useGetCustomerAttributesQuery'
import useGetCustomerJourneyQuery from 'features/unifiedFlow/api/queries/useGetCustomerJourneyQuery'
import useGetPrivacyRegionsQuery from 'features/unifiedFlow/api/queries/useGetPrivacyRegionsQuery'
import useGetProductCatalogQuery from 'features/unifiedFlow/api/queries/useGetProductCatalogQuery'

const REGIONAL_INGESTION_URLS = process.env.REACT_APP_REGIONAL_INGESTION_URLS

if (!REGIONAL_INGESTION_URLS) {
  throw new Error('REACT_APP_REGIONAL_INGESTION_URLS is not defined')
}

export const getRegionalizedIngestionUrl = (
  region: string
): string | undefined => {
  return (
    REGIONAL_INGESTION_URLS &&
    JSON.parse(REGIONAL_INGESTION_URLS)[region.toLowerCase()]
  )
}

const useLoadPersonalizationSelectors = ({
  privacyRegion,
}: {
  privacyRegion: string | undefined
}) => {
  const regionalizedIngestionUrl =
    privacyRegion && getRegionalizedIngestionUrl(privacyRegion)

  const { data: brandVoicesData, ...brandVoicesQuery } =
    useGetBrandVoicesQuery()
  const { data: privacyRegions, ...privacyRegionsQuery } =
    useGetPrivacyRegionsQuery()
  const { data: productCatalog, ...productCatalogQuery } =
    useGetProductCatalogQuery({
      baseUrl: regionalizedIngestionUrl,
    })
  const { data: customerAttributeData, ...customerAttributesQuery } =
    useGetCustomerAttributesQuery({
      baseUrl: regionalizedIngestionUrl,
    })
  const { data: customerJourneys, ...customerJourneyQuery } =
    useGetCustomerJourneyQuery()

  const brandVoices = useMemo(
    () =>
      brandVoicesData?.map((brandVoice) => ({
        label: brandVoice.name,
        value: brandVoice.id,
      })),
    [brandVoicesData]
  )

  return {
    brandVoices,
    brandVoicesQuery,
    privacyRegions,
    privacyRegionsQuery,
    productCatalog,
    productCatalogQuery,
    customerAttributeData,
    customerAttributesQuery,
    customerJourneys,
    customerJourneyQuery,
  }
}

export default useLoadPersonalizationSelectors
